import "./FromikPhoneNumberComponent.scss";
import {useCallback} from "react";
import FormikInputComponent from "../formik-input/FormikInputComponent";
import {UsFlagIcon} from "../../../../constants/ImageConfig";

interface FromikPhoneNumberComponentProps {
    formikField: any
    placeholder: string
    label?: string
    required?: boolean
    onUpdate?: Function
    errorMessage?: any
    maxLength?: number;
    disabled?: boolean;
}

const FromikPhoneNumberComponent = (props: FromikPhoneNumberComponentProps) => {

    const {placeholder, formikField, label, required, onUpdate, maxLength,disabled} = props
    const {field, form} = formikField;
    const {name} = field;
    const {setFieldTouched, setFieldValue} = form;

    const textChangeHandler = useCallback((value: any) => {
        const x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        const tempValue = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
        if(tempValue === ''){
            setFieldValue(name, value);
            setFieldTouched(name);
        }
        else{
            setFieldValue(name, tempValue);
            setFieldTouched(name);
            onUpdate && onUpdate(tempValue);
        }
    }, [setFieldValue, setFieldTouched, name, onUpdate]);

    return (
        <div className={'formik-phone-number-component'}>
            {/*{label && <LabelComponent title={label + (required ? " * " : "")}/>}*/}
            <FormikInputComponent
                // showLabel={false}
                placeholder={placeholder}
                onUpdate={textChangeHandler}
                maxLength={maxLength}
                label={label}
                prefix={
                    <div className={"phone-input-flag-prefix-wrapper"}>
                        <div className="phone-input-flag-wrapper">
                            <UsFlagIcon/>
                        </div>
                        <div className="phone-input-flag-prefix">
                            +1
                        </div>
                    </div>
                }
                required={required}
                disabled={disabled}
                type={"text"}
                formikField={formikField}
            />
        </div>
    );

};

export default FromikPhoneNumberComponent;
